// Mock data for StreetFleet courier website (frontend-only teaser)
import { Zap, Timer, Rocket, MoonStar } from 'lucide-react';

export const BRAND = {
  name: 'StreetFleet',
  logo: 'https://customer-assets-jai6qajn.emergentagent.net/job_courier-connect-hub-1/artifacts/zjimktz1_street-fleet.png',
  phone: '647-352-4444',
  phoneHref: 'tel:+16473524444',
  email: 'info@streetfleet.ca',
  loginUrl: 'https://secure.ontime360.com/sites/StreetFleetCA',
  address: {
    line1: '40 Toledo Crescent',
    city: 'Thornhill',
    region: 'Ontario',
    postal: 'L4J 8J8',
    country: 'Canada',
  },
  cyan: '#17A2C4',
  gray: '#4E4E50',
};

export const NAV_LINKS = [
  { label: 'Services', to: '/services' },
  { label: 'Why StreetFleet', to: '/#why' },
  { label: 'Coverage', to: '/#coverage' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export const SERVICES = [
  {
    id: 'same-day',
    icon: Zap,
    name: 'Same-Day',
    tagline: 'Delivered before the day is done',
    desc: 'Guaranteed same-business-day pickup and delivery anywhere across Toronto and the GTA. Perfect for documents, parts and time-sensitive parcels.',
    eta: 'By end of day',
    features: ['Scheduled pickup windows', 'Full GTA coverage', 'Proof of delivery'],
    image: 'https://images.unsplash.com/photo-1620455800201-7f00aeef12ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxjb3VyaWVyJTIwZGVsaXZlcnl8ZW58MHx8fHwxNzg5OTE3NTQ3fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'rush',
    icon: Timer,
    name: 'Rush',
    tagline: 'On the road within the hour',
    desc: 'A dedicated driver dispatched fast with a 3-hour delivery window. When it matters today but not in the next 60 minutes, Rush is the sweet spot.',
    eta: 'Within 3 hours',
    features: ['Priority dispatch', 'Live status updates', 'Direct-to-recipient'],
    image: 'https://images.unsplash.com/photo-1558410177-183cf64cc773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxiaWtlJTIwbWVzc2VuZ2VyfGVufDB8fHx8MTc4OTkxNzU0N3ww&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'asap',
    icon: Rocket,
    name: 'ASAP',
    tagline: 'Straight there, no stops',
    desc: 'Our fastest tier. A driver heads directly to your pickup and drives straight to the destination \u2014 no other stops, the quickest possible transit time.',
    eta: 'Direct \u2014 fastest route',
    features: ['Exclusive dedicated vehicle', 'Non-stop direct route', 'Immediate dispatch'],
    image: 'https://images.unsplash.com/photo-1641199788912-9a7385a35c82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxkZWxpdmVyeSUyMHZhbnxlbnwwfHx8fDE3ODk5MTc1NDd8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 'after-hours',
    icon: MoonStar,
    name: 'After Hours',
    tagline: 'Evenings, weekends & holidays',
    desc: 'The city never stops and neither do we. Overnight, weekend and holiday courier service for deliveries that fall outside standard business hours.',
    eta: 'Evenings & weekends',
    features: ['24/7 availability', 'Weekend & holiday runs', 'Emergency dispatch'],
    image: 'https://images.pexels.com/photos/6407553/pexels-photo-6407553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
];

export const FEATURES = [
  {
    title: 'Real-time dispatch',
    desc: 'Our dispatch team and OnTime360 platform keep every job tracked from pickup to signature.',
  },
  {
    title: 'Fully insured',
    desc: 'Every shipment is handled by vetted, insured drivers for complete peace of mind.',
  },
  {
    title: 'GTA specialists',
    desc: 'We know Toronto\u2019s streets, traffic and shortcuts \u2014 local knowledge that saves you time.',
  },
  {
    title: 'Business accounts',
    desc: 'Simple monthly invoicing, recurring routes and volume pricing for busy teams.',
  },
];

export const STATS = [
  { value: '15+', label: 'Years on the road' },
  { value: '99.4%', label: 'On-time delivery' },
  { value: '24/7', label: 'Dispatch coverage' },
  { value: '500+', label: 'Business clients' },
];

export const COVERAGE = [
  'Toronto', 'North York', 'Scarborough', 'Etobicoke', 'Mississauga', 'Brampton',
  'Vaughan', 'Markham', 'Richmond Hill', 'Thornhill', 'Oakville', 'Pickering',
];

export const INDUSTRIES = [
  'Legal & Law Firms', 'Medical & Pharma', 'Manufacturing & Parts', 'Print & Media',
  'Financial Services', 'Retail & E-commerce',
];

export const TESTIMONIALS = [
  {
    quote: 'StreetFleet has been our go-to courier for years. Their same-day service is genuinely same-day, every time.',
    name: 'Jennifer M.',
    role: 'Office Manager, Downtown Law Firm',
  },
  {
    quote: 'When we need something across the city ASAP, one call and a driver is on the way. Reliable and professional.',
    name: 'David K.',
    role: 'Operations Lead, Medical Supplier',
  },
  {
    quote: 'The after-hours service saved a critical weekend delivery for us. Can\u2019t recommend them enough.',
    name: 'Priya S.',
    role: 'Logistics Coordinator',
  },
];

export const FAQS = [
  { q: 'What areas do you cover?', a: 'We provide courier service across Toronto and the entire Greater Toronto Area (GTA), including Mississauga, Brampton, Vaughan, Markham, Richmond Hill and beyond.' },
  { q: 'How fast can you pick up?', a: 'For ASAP and Rush jobs a driver is typically dispatched within minutes. Same-day pickups are scheduled within your chosen window.' },
  { q: 'Do you offer business accounts?', a: 'Yes. We offer monthly invoicing, recurring scheduled routes and volume pricing for business clients. Contact us to set up an account.' },
  { q: 'Can I track my delivery?', a: 'Absolutely. Existing customers can log in to our OnTime360 customer portal to place orders and track deliveries in real time.' },
];
